// Demo.jsx
import React, { useState } from "react";

const videos = [

        

  {
      title: "Angle and its measurement Part 1 | 11th Maths",
      id: "ZaaFTyHYNVQ",
      teacher: "Prof. Vijay Yeole",
    },
    {
      title: "Trigonometry-1 | Lec-1 | Class 11th Mathss",
      id: "SmVKrUH1-cA",
      teacher: "Prof. Vijay Yeole",
    },
    {
      title: "Trigonometry-2 EX.3.1 Class 11th Maths",
      id: "8egn9F3ExGw",
      teacher: "Prof. Vijay Yeole",
    },   
       {
      title: "Angle & it's Measurement Ex",
      id: "8egn9F3ExGw",
      teacher: "Prof. Vijay Yeole",
    },  
      {
      title: "Trigonometry 1 | Ex.2.1 | Lec-4 ",
      id: "PLB_Vlk99Ls",
      teacher: "Prof. Vijay Yeole",
    },   
   


];

export default function Demo() {
    const [active, setActive] = useState(0);

    const remaining = videos.filter((_, i) => i !== active);

    return (
        <section className="min-h-screen bg-gradient-to-br from-indigo-100 via-white to-purple-100 py-16">
            <div className="container mx-auto px-6">

                {/* Heading */}
                <h1 className="text-4xl md:text-5xl font-extrabold text-center text-indigo-700 mb-12 drop-shadow-sm">
                    Demo Lectures
                </h1>

                <div className="grid md:grid-cols-3 gap-8 max-w-6xl mx-auto">

                    {/* LEFT — Main Player */}
                    <div className="md:col-span-2 bg-white rounded-3xl shadow-xl border-2 border-indigo-200 overflow-hidden hover:shadow-2xl transition-all duration-300">
                        <div className="aspect-video">
                            <iframe
                                className="w-full h-full"
                                src={`https://www.youtube.com/embed/${videos[active].id}?autoplay=1&rel=0&modestbranding=1&showinfo=0&controls=1`}
                                title={videos[active].title}
                                allow="autoplay; encrypted-media"
                                allowFullScreen
                            />

                        </div>
                        <div className="p-6 bg-gradient-to-r from-indigo-50 to-purple-50 border-t border-indigo-100">
                            <h2 className="text-2xl font-bold text-slate-800 tracking-wide">
                                {videos[active].title}
                            </h2>
                        </div>
                    </div>

                    {/* RIGHT — Playlist */}
                    <div
                        className={`flex flex-col gap-5 ${remaining.length === 2 ? "justify-center" : ""
                            }`}
                    >
                        {remaining.map((v) => {
                            const index = videos.findIndex((vid) => vid.id === v.id);
                            return (
                                <button
                                    key={v.id}
                                    onClick={() => setActive(index)}
                                    className="group flex gap-4 p-4 rounded-2xl border-2 border-indigo-200 bg-white hover:bg-indigo-600 hover:border-indigo-600 hover:scale-[1.03] transition-all duration-300 shadow-md"
                                >
                                    <img
                                        src={`https://img.youtube.com/vi/${v.id}/mqdefault.jpg`}
                                        alt={v.title}
                                        className="w-28 h-16 object-cover rounded-lg shadow-sm group-hover:opacity-90"
                                    />
                                    <div className="text-left">
                                        <p className="font-semibold text-slate-800 text-sm group-hover:text-white">
                                            {v.title}
                                        </p>
                                        <span className="text-xs text-indigo-500 group-hover:text-indigo-200">
                                            Click to play
                                        </span>
                                    </div>
                                </button>
                            );
                        })}
                    </div>
                </div>
            </div>
        </section>
    );
}
